export const DATA_MASKS = {
  date: 'MM/dd/yyyy',
  dateShortYear: 'MM/dd/yy',
  phone: '(000)000-0000'
};
